import { render, staticRenderFns } from "./VideoSettings.vue?vue&type=template&id=50bcbf4a&"
import script from "./VideoSettings.vue?vue&type=script&lang=js&"
export * from "./VideoSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports